module.exports = __webpack_public_path__ + "img/line_arrow.2f912909.png";